



















import Vue from 'vue';
import {
  item,
  Item,
  brand,
  Brand,
} from 'mostra';
import * as page from '@/modules/page';
const pageParams = page.tabParams.item;

interface DataType {
  loading: boolean;
  isChanged: boolean
  targetPageName: string;
  editPageName: string;
  item: Item | null;
  brands: Brand[];
  notFound: boolean;
  owner: string | null;
}

export default Vue.extend({
  name: 'exhibitor-item',
  data(): DataType {
    return {
      loading: true,
      isChanged: false,
      targetPageName: 'exhibitor-item-copy',
      editPageName: 'exhibitor-item-edit',
      item: null,
      brands: [],
      notFound: false,
      owner: null,
    };
  },
  computed: {
    copyId(): string | null {
      return this.$route.query.copy as string | null;
    },
    currentPage() {
      return this.$route.query.page as string;
    },
  },
  watch: {
    item: {
      handler(_, oldVal: any) {
        if (oldVal) {
          this.isChanged = true;
        }
      },
      deep: true,
    },
  },
  async beforeRouteLeave(to, from, next) {
    if (this.isChanged) {
      const r = await (this.$refs.dialog as any).show();
      next(r);
    } else {
      next();
    }
  },
  methods: {
    async onClickSave() {
      try {
        this.$loading(true);
        this.loading = true;
        if (!this.item) throw Error('this.item is null');
        this.item = await item.save(this.$auth.uid, this.item);
        this.$success('保存しました。');
        this.isChanged = false;
        this.$router.push({
          name: this.editPageName,
          query: {
            page: 'preview',
            id: this.item.id,
          },
        });
      } catch (error: any) {
        this.$error('保存に失敗しました。', error);
      } finally {
        this.loading = false;
        this.$loading(false);
      }
    },
    async fetchData() {
      try {
        this.loading = true;
        this.$loading(true);
        this.owner = this.$auth.cid;

        if (this.item) return;

        if (!this.copyId) {
          throw Error('can not get id');
        }

        this.item = await item.copy(this.copyId);
        this.isChanged = true;

        if (!this.item) {
          this.notFound = true;
          return;
        }

        this.brands = await brand.loadsByOwner(this.owner);
      } catch (error: any) {
        this.$fatal(error);
      } finally {
        this.loading = false;
        this.$loading(false);
      }
    },
    checkQueryParamsValid() {
      if (!this.currentPage || !pageParams.includes(this.currentPage)) {
        this.$router.replace({
          name: this.targetPageName,
          query: {
            page: 'settings',
            copy: this.copyId,
          },
        });
      }
    },
  },
  async beforeRouteUpdate(to, from, next) {
    next();
    this.checkQueryParamsValid();
    await this.fetchData();
  },
  async mounted() {
    this.checkQueryParamsValid();
    await this.fetchData();
  },
});
